






function sliderTabSelected() {


    function buildingOwlCarousels(){


        if (jQuery(".tabsldrsec-tpl-m7").length) {


            function owlInitializeOne() {

                if (jQuery(window).width() >= 768) {


                    jQuery('.tabsldrsec-tpl-m7 .js-tsowl-m7').owlCarousel({
                        rtl: true,
                        margin: 10,
                        loop: false,
                        center: false,
                        lazyLoad: true,
                        nav: false,
                        dots: true,
                        navText: ["<i class='nf nf-rarrw'></i>", "<i class='nf nf-larrw'></i>"],
                        autoplay: false,
                        responsive: {
                            0: {
                                items: 2.2,
                                // nav: false,
                            },
                            400: {
                                items: 2,
                                // nav: false,
                            },
                            480: {
                                items: 3.5,
                                // nav: false,
                            },
                            576: {
                                items: 3.4,
                                // nav: false,
                                // loop: false,
                                // center: false,
                                nav: true,
                            },
                            768: {
                                items: 5,
                                // center: true,
                                // loop: false,
                                nav: true,
                            },
                            992: {
                                items: 6,
                                margin: 17,
                                // center: false,
                                // loop: false,
                                nav: true,
                            },
                            1200: {
                                items: 8,
                                margin: 17,
                                // center: false,
                                // loop: false,
                                nav: true,
                            },
                        }
                    });
                }
                else{
                    jQuery('.tabsldrsec-tpl-m7 .js-tsowl-m7').owlCarousel('destroy');
                }
            };


            jQuery(document).ready(function(e) {
                owlInitializeOne();
            });

            jQuery(window).resize(function() {
                owlInitializeOne();
            });
        }
    }



    function tabbarOpen(){

        if (jQuery(".tabsldrsec-tpl-m7").length) {
        
            var parentSlider                  = ('.tabsldrsec-tpl-m7');
            // var itemTabBar                    = jQuery('.tabsldrsec-tpl-m7 .js-tsnavitem-m7 .js-tsnavlink-m7');
            var itemTabBarNew                 = jQuery('.tabsldrsec-tpl-m7 .js-tsnavitem-m7 .js-tsnavlink-m7');
            var parentItemTabBarNew           = jQuery('.tabsldrsec-tpl-m7 .js-tsnavitem-m7');
            var parentItemTabBarNewFirstChild = jQuery('.tabsldrsec-tpl-m7 .js-tsnavitem-m7.first-child-m7');
            // var buttonCloseTab                = jQuery('.tabsldrsec-tpl-m7 .headfltr-tpl-m7 .js-closefltr-m7');

            // var sliderPanelBackdrop           = ".tabsldrsec-tpl-m7 .spbackdrop-m7";
            // var parrentBackdrop               = ".tabsldrsec-tpl-m7";
            // var containerTabPane              = ".tabsldrsec-tpl-m7 .tabcontent-m7 .sptpane-m7";
            // var containerTabPaneChild         = ".tabsldrsec-tpl-m7 .tabcontent-m7 .sppin-m7";

            // var mainItemTabBar                = ".acrdinimgsec-tpl-m7.astab-m7 .asnav-m7 .asnlnk-m7";

            var activeClass                   = "active";
            var showClass                     = "show";
            var activeShowClass               = "active show";
            var activeItemSlider              = "active-m7";
            // var mobileFixer                   = "mobfix-tpl-m7";
            // var paneNewSlider                 = ".tabsldrsec-tpl-m7 .sptpane-m7";
            // var paneNewSliderFirstChild       = ".tabsldrsec-tpl-m7 .sptpane-m7:first-child";
            var tabPane                       = ".tabsldrsec-tpl-m7 .tab-content .tab-pane";
            // var parentSectionTab              = ".acrdinimgsec-tpl-m7.astab-m7";


            var deviceWidth = jQuery(window).width();


            var aciveTabPane = function(event){


                var x = jQuery(event.currentTarget);  
                var parentThisTabContent = jQuery(x).parents(parentSlider);

                parentThisTabContent.find(tabPane).removeClass(activeShowClass);
                // jQuery(x).parents(parentSlider).find(".js-tsnavitem-m7").removeClass(activeItemSlider);  

                 // investo 
                jQuery(x).parents(parentSlider).find(itemTabBarNew).removeClass(activeClass);  
            }


            var activeTab = function(event){

                var x = jQuery(event.currentTarget);

                aciveTabPane(event);

                var parentThisTabContent = jQuery(x).parents(parentSlider);
                // var hrefTab = jQuery(x).attr('href');
                var hrefTab = jQuery(x).attr('data-target');


                parentThisTabContent.find(tabPane + hrefTab).tab(showClass);
                // jQuery(x).parents(".js-tsnavitem-m7").addClass(activeItemSlider); 

                // investo
                jQuery(x).addClass(activeItemSlider); 
            }


            // itemTabBar.on('click', function (evt) {
            //     evt.preventDefault();

            //     activeTab(evt);
            // });


            itemTabBarNew.on('click', function (evt) {
                evt.preventDefault();

                activeTab(evt);

                // if(jQuery(window).width() < 768 ){
                //     jQuery(parrentBackdrop).append('<div class="spbackdrop-m7"></div>');
                //     jQuery("html").addClass(mobileFixer);
                // }
            });


            var activeMainTab = function(event){
                var x = jQuery(event.currentTarget);

                // var parentThisTabContent = jQuery(x).parents(parentSectionTab);
                // var dataPclass = jQuery(x).data('pclass');


                // parentThisTabContent.attr('class', function(i, c){
                //     return c.replace(/(^|\s)asactive-\S+/g, '');
                // });

                // parentThisTabContent.addClass(dataPclass);
            }


            // jQuery(mainItemTabBar).on('click', function (evt) {
            //     evt.preventDefault();

            //     activeMainTab(evt);
            // });


            var closeTabMobile = function(event){

                var x = jQuery(event.currentTarget);

                aciveTabPane(event);
            
                var parentThisTabContent = jQuery(x).parents(parentSlider);
                var hrefTab = jQuery(x).attr('href');

                parentThisTabContent.find(tabPane + hrefTab).tab('hide');

                // jQuery(sliderPanelBackdrop).detach();
                // jQuery("html").removeClass(mobileFixer);
            } 



            // buttonCloseTab.on('click', function (evt) {

            //     evt.preventDefault();
            //     closeTabMobile(evt);
            // });

            var showTabPanMobile = function(){
                
                if(jQuery(window).width() < 768 ){

                    // jQuery(paneNewSlider).removeClass(activeShowClass);
                    jQuery(parentItemTabBarNew).removeClass(activeItemSlider);
                }
            }

            showTabPanMobile();



            var previousWidth = jQuery(window).width();

            // window.onresize = function(){
            jQuery(window).on("resize", function () {

                var currentWidth = jQuery(window).width();
                var threshold = 768;

                if (previousWidth < threshold && currentWidth >= threshold){

                    // jQuery(paneNewSlider).removeClass(activeShowClass);
                    jQuery(paneNewSliderFirstChild).addClass(activeShowClass);
                    jQuery(parentItemTabBarNew).removeClass(activeItemSlider);
                    jQuery(parentItemTabBarNewFirstChild).addClass(activeItemSlider);
                }

                else if (previousWidth > threshold && currentWidth <= threshold){
                    
                    // jQuery(paneNewSlider).removeClass(activeShowClass);
                    jQuery(parentItemTabBarNew).removeClass(activeItemSlider);
                    // jQuery(sliderPanelBackdrop).detach();
                    // jQuery("html").removeClass(mobileFixer);
                }

                previousWidth = currentWidth;

                var deviceWidth = jQuery(window).width();
            });


            // jQuery(document).on("mouseup  tap touch ", function (e) {

            //     if( deviceWidth < 768){

            //         var container = jQuery(containerTabPaneChild); 
            //         // Give you class or ID

            //         if (!container.is(e.target) &&
            //             container.has(e.target).length === 0) {
            //             closeTabMobile(e);
            //             jquery(containerTabPane).removeClass(activeShowClass);
            //             jquery(parentItemTabBarNew).removeClass(activeItemSlider);
            //         }
            //     }
            // });
        }
    }


    buildingOwlCarousels();
    tabbarOpen();
};







export {sliderTabSelected};